<router-outlet></router-outlet>
<medmio-spinner></medmio-spinner>
